<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import CreatorSpotlightAjax from '@ajax/creator_spotlight';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  let availableExpertises = [];
  let selectedExpertises = [];
  let maxSelected = 4;
  let warn = false;

  let loadAllCreatorSpotlightExpertises = async function () {
    let res = await CreatorSpotlightAjax.getAllSpotlightExpertises();
    availableExpertises = res.expertises;
  };

  let loadUserCreatorSpotlightExpertises = async function () {
    let res = await CreatorSpotlightAjax.getSpotlightExpertises();
    selectedExpertises = [...res.expertises];
  };

  let setCreatorSpotlightExpertise = async function (val) {
    let res = await CreatorSpotlightAjax.createSpotlightExpertise({ id: val });
    return res;
  };

  let removeCreatorSpotlightExpertise = async function (val) {
    let res = await CreatorSpotlightAjax.deleteSpotlightExpertise(val);
    warn = false;
    return res;
  };

  const toggleExpertiseSelect = function (currentValue) {
    if (selectedExpertises.some((i) => i.id === currentValue.id)) {
      selectedExpertises = selectedExpertises.filter(function (expertise) {
        return expertise.id != currentValue.id;
      });
      removeCreatorSpotlightExpertise(currentValue.id);
    } else {
      if (selectedExpertises.length < maxSelected) {
        selectedExpertises = [...selectedExpertises, currentValue];
        setCreatorSpotlightExpertise(currentValue.id);
      } else {
        warn = true;
      }
    }
  };

  $: isSelected = (id) => {
    return selectedExpertises.some((i) => i.id === id);
  };

  loadUserCreatorSpotlightExpertises();
  loadAllCreatorSpotlightExpertises();
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-expertise {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      margin-bottom: 16px;
      color: #717171;

      &.warn {
        color: #ff5567;
      }
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    .select-container {
      display: inline-flex;
      gap: 12px;
      flex-wrap: wrap;

      &.justify-center {
        justify-content: center;
      }
    }

    .expertise-container {
      margin-bottom: 24px;
    }

    .ui-select-label {
      border: 1px solid #e3e3e3;
      color: #717171;
      padding: 8px 16px;
      border-radius: 32px;
      font-weight: 500;
      cursor: pointer;
      transition: 200ms;

      @media (hover: hover) {
        &:hover {
          background-color: #f5f5f5;
        }
      }

      &.selected {
        border-color: #717171;
        background-color: #f1f1f1;
        color: #1c1c1c;
      }

      &.disabled {
        cursor: default;
        background: none;
      }
    }
  }
</style>

<div class="creator-spotlight-expertise" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Ask me for recs about...</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>
  <p class="ui-subtitle" class:warn={warn}>Select up to {maxSelected}</p>

  <div class="expertise-container select-container justify-center">
    {#each availableExpertises as expertise}
      <div class="select-item">
        <div
          class="ui-select-label"
          class:selected={isSelected(expertise.id)}
          class:disabled={selectedExpertises.length === maxSelected && !isSelected(expertise.id)}
          on:click={() => toggleExpertiseSelect(expertise)}>
          {expertise.value}
        </div>
      </div>
    {/each}
  </div>
  <div class="finished-btn">
    <Button
      disabled={selectedExpertises.length < 1}
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={selectedExpertises.length < 1 ? 'Select at least 1' : 'Continue'}
      on:click={() => {
        dispatch('finished');
      }} />
  </div>
</div>
